var _Circle, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";
var SvgIcDaySelected = function SvgIcDaySelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EC9876"
  })), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#ic_day_selected_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M15 22.2 10.8 18l-1.4 1.4L15 25l12-12-1.4-1.4z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "ic_day_selected_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M6 6h24v24H6z"
  })))));
};
export default SvgIcDaySelected;